import React, { useEffect, useState } from 'react';
import {
  SessionState,
  useSessionRefresh,
  useSessionState,
} from '@atlas/session';

import {
  Button,
  ButtonRow,
  ModalDialog,
  Paragraph,
  Loading,
} from '@piggybank/core';
import { Translation } from 'srcAlias/client/locale';
import { useSelector, useDispatch } from 'react-redux';
import { get } from 'lodash-es';
import { redirectToLogOffUrl } from 'srcAlias/client/utils/redirectToLogOffUrl';
import { setAbsoluteSessionTimoutFlagData } from 'srcAlias/client/state/actions/sessionTimeoutActions';
import config from 'configAlias';
import callSessionTimeout from './callSessionTimeout';
import { useTrackPageViewAnalyticsFunction } from 'srcAlias/client/global/customHooks/useTrackPageViewAnalytics';

export const SessionTimeout = () => {
  const dispatch = useDispatch();
  const sessionState = useSessionState();
  const refreshSession = useSessionRefresh();
  const [isLoading, setIsLoading] = useState(false);
  const absoluteSessionTimeoutFlag = get(
    config,
    'absoluteSessionTimeoutFlag',
    false
  );
  // eslint-disable-next-line
  const sessionId = useSelector((state) =>
    get(state, 'sessionId', 'ERROR_CREATING_SESSION_ID')
  );

  useEffect(() => {
    if (sessionState === SessionState.TIMEOUT) {
      if (absoluteSessionTimeoutFlag === false) {
        redirectToLogOffUrl();
      } else {
        dispatch(setAbsoluteSessionTimoutFlagData(true));
      }
    }
  }, [sessionState]);

  const clickContinue = async () => {
    setIsLoading(true);
    refreshSession();
    const sessiontimeoutResponseStatus = await callSessionTimeout(
      refreshSession,
      setIsLoading,
      sessionId
    );

    if (sessiontimeoutResponseStatus) {
      setIsLoading(false);
      if (sessiontimeoutResponseStatus === 200) {
        refreshSession();
      } else {
        if (absoluteSessionTimeoutFlag === true) {
          dispatch(setAbsoluteSessionTimoutFlagData(true));
        } else {
          redirectToLogOffUrl();
        }
      }
    }
  };
  useTrackPageViewAnalyticsFunction('sessionTimeoutReminder');
  return !isLoading ? (
    <ModalDialog
      title={<Translation path="sessionTimeout.title" />}
      show={sessionState === SessionState.WARNING}
      getApplicationNode={() => document.getElementById('root')}
      alert
      dismissible={false}
    >
      <Paragraph marginBottom={6}>
        <Translation path="sessionTimeout.description" />
      </Paragraph>
      <ButtonRow>
        <Button
          name={'sessionTimeoutWarning'}
          id={'pb-ModalDialog__Button'}
          type="button"
          onClick={clickContinue}
        >
          <Translation path="sessionTimeout.continueButton" />
        </Button>
      </ButtonRow>
    </ModalDialog>
  ) : (
    <Loading show={true} />
  );
};

export default SessionTimeout;
